import React from 'react';
import PropTypes from 'prop-types';
import { Textarea } from '@fiverr-private/fit';
import * as Translations from '../../providers/i18n';
import './style.scss';

const MAX_LENGTH = 250;

function AddPersonalMessage({ onChange, content, i18n }) {
    return (
        <div className="personal-message-wrapper">
            <Textarea className="personal-message" onChange={onChange} maxLength={MAX_LENGTH} showCounter placeholder={i18n.t('attachments_preview.invite.let_them_know')}>{content}</Textarea>
        </div>
    );
}

AddPersonalMessage.propTypes = {
    onChange: PropTypes.func,
    content: PropTypes.string,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

export default Translations.connect(AddPersonalMessage);
